import { forwardRef } from "react";

import { ChevronRight } from "lucide-react";
import { globalProps } from "neetocommons/initializers";
import { useTranslation } from "react-i18next";

const MenuButton = forwardRef((props, ref) => {
  const { t } = useTranslation();

  return (
    <button
      {...{ ref }}
      className="hover:bg-accent flex w-full items-center gap-2 rounded-md px-2.5 py-2 text-start"
      data-testid="workspace-display"
      type="button"
      {...props}
    >
      <span className="flex flex-grow flex-col gap-1.5">
        <span className="text-sm font-medium">
          {t("neetoMolecules.sidebar.workspace")}
        </span>
        {globalProps.organization?.name && (
          <span className="text-muted-foreground text-xs">
            {globalProps.organization.name}
          </span>
        )}
      </span>
      <ChevronRight className="shrink-0 rtl:scale-x-[-1]" size={18} />
    </button>
  );
});

MenuButton.displayName = "WorkspaceMenuButton";

export default MenuButton;
